import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { compareAsc, format } from 'date-fns'
import Skills from "./Skills/Skills";
import {httpCreateUserGroup} from "../Employee/Skills/api/calls";

function AddEmployeeCom() {
	const salutationRef = useRef();
	const fnameRef = useRef();
	const peremailRef = useRef();
	const dobRef = useRef();
	const companyRef = useRef();
	const divisionRef = useRef();
	const deptRef = useRef();
	const dofjRef = useRef();
	const designationjRef = useRef();
	const empcatRef = useRef();
	const empshiftRef = useRef();

	let navigate = useNavigate();
	let SERVER_URL = process.env.REACT_APP_API_URL;
	let BASE_URL = process.env.REACT_APP_APP_URL;
	let token = JSON.parse(localStorage.getItem('key'));

	const [skillData,setUserSkillData] = useState([]);

	const [salutation, setSalutation] = useState('');
	const [fname, setFname] = useState('');
	const [mname, setMname] = useState('');
	const [lname, setLname] = useState('');
	const [gargen, setGargen] = useState('');
	const [gender, setGender] = useState(1);
	const [dateofbirth, setDateofbirth] = useState('');
	const [marriage, setMarriage] = useState('');
	const [bloodgroup, setBloodgroup] = useState('');
	const [nationality, setNationality] = useState('');
	const [adhaarname, setAdhaarname] = useState('');
	const [adhaarnumber, setAdhaarnumber] = useState('');
	const [pancardnumber, setPancardnumber] = useState('');
	const [company, setCompany] = useState('');
	const [division, setDivision] = useState('');
	const [department, setDepartment] = useState('');

	const [empcode, setEmpcode] = useState('');
	const [empstatus, setEmpstatus] = useState(1);
	const [dateofjoining, setDateofjoining] = useState('');
	const [probation_period, setProbation_period] = useState('');
	const [confirmationdate, setConfirmationdate] = useState('');

	const [designation, setDesignation] = useState('');
	const [empcategory, setEmpcategory] = useState('');
	const [noticeperiod, setNoticeperiod] = useState('');

	const [salaryType, setSalaryType] = useState('');
	const [ctc, setCtc] = useState('');
	const [bankname, setBankname] = useState('');
	const [accountnumber, setAccountnumber] = useState('');
	const [ifsc, setIfsc] = useState('');
	const [pfapplicable, setPfapplicable] = useState('');
	const [pfnumber, setPfnumber] = useState('');
	const [pfgroup, setPfgroup] = useState('');
	const [uan_number, setUan_number] = useState('');
	const [pt_applicable, setPt_applicable] = useState('');

	const [role, setRole] = useState('');
	const [depdata, setDepdata] = useState([]);
	const [roledata, setRoledata] = useState([]);
	const [comdata, setComdata] = useState([]);

	const [color, setColor] = useState('');
	const [errmsg, setErrmsg] = useState('');
	const [buttonstatus, setbuttonstatus] = useState(true);
	const [persona_email, setPersonal_email] = useState('');
	const [contact_number, setContact_number] = useState('');
	const [timezone, setTimezone] = useState('');
	// const [officialemailstatus, setOfficialemailstatus] = useState(true);


	const [err, setErr] = useState('');
	const [errMsgsalutaion, setErrMsgsalutaion] = useState('');
	const [errMsgfname, setErrMsgfname] = useState('');
	const [errMsgpersona_email, setErrMsgpersona_email] = useState('');
	const [errMsgdateofbirth, setErrMsgdateofbirth] = useState('')
	const [errMsgcompany, setErrMsgcompany] = useState('');
	const [errMsgdivision, setErrMsgdivision] = useState('')
	const [errMsgdepartment, setErrMsgdepartment] = useState('');
	const [errMsgdateofjoining, setErrMsgdateofjoining] = useState('');
	const [errMsgdesignation, setErrMsgdesignation] = useState('');
	const [errMsgempcat, setErrMsgempcat] = useState('');
	const [errMsgShift, setErrMsgShift] = useState('');
	const [reportingmanager, setreportingmanager] = useState('');
	const [systemRole, setSystemRole] = useState('');
	const [shift, setShift] = useState('');
	const [shiftList, setShiftList] = useState([]);
	useEffect(() => {
		getCompanyList()
		getDepartmentList()
		getLocation()
		getReportingManager()
		getShiftList()
	}, [])

	const getShiftList = () => {
		const response = fetch(SERVER_URL + `api/common/getshiftlist`,
			{
				method: 'post',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				body: JSON.stringify({
					emailpersonal: persona_email,
					city: '',
				}),
			}).then(res => res.json())
			.then(data => {
				setShiftList(data.result)
			})
	}
	const [reportimgManageList, setReportimgManageList] = useState([]);
	const getReportingManager = () => {
		const response = fetch(SERVER_URL + `api/common/manager_list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},

			}).then(res => res.json())
			.then(data => {
				setReportimgManageList(data.result)
			});
	}


	const getCompanyList = () => {
		const response = fetch(SERVER_URL + `api/common/company_list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},

			}).then(res => res.json())
			.then(data => {
				setComdata(data.result)
			});
	}
	const getDepartmentList = () => {
		const response = fetch(SERVER_URL + `api/common/department_list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => {
				setDepdata(data.result)
			});
	}
	function handleChange(deptid) {
		setDepartment(deptid)
		const response = fetch(SERVER_URL + `api/common/get_department_role`,
			{
				method: 'PUT',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				body: JSON.stringify({
					id: deptid,
				}),
			}).then(res => res.json())
			.then(data => {
				setRoledata(data.result)
			});
	}
	const userSkillParentCallback = (userSkillChildData) =>{
		// console.log('userSkillChildData')
		// console.log(userSkillChildData)
		setUserSkillData(userSkillChildData)

	}
	const handleAddEMP = () => {
		
		var usernameRegex = /^[a-zA-Z0-9]+([a-zA-Z0-9](_|-| )[a-zA-Z0-9])*[a-zA-Z0-9]+$/;
		let regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
		setErrMsgsalutaion('')
		setErrMsgfname('')
		setErrMsgpersona_email('')
		setErrMsgdateofbirth('')
		setErrMsgcompany('')
		setErrMsgdivision('')
		setErrMsgdepartment('')
		setErrMsgdateofjoining('')
		setErrMsgdesignation('')
		setErrMsgempcat('')
		setErr('')

		setEmp_profile(0)
		setEmp_spc(0)
		setEmp_dtl(0)
		if (salutation == '') {
			setEmp_profile(1)
			setErr('red')
			setErrMsgsalutaion('This field is required')
			salutationRef.current.focus();
			return false;
		}
		else if (!usernameRegex.test(fname)) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgfname('This field is required')
			fnameRef.current.focus();
			return false;
		} else if (!regEmail.test(persona_email)) {
			setEmp_profile(1)
			setErr('red')
			setErrMsgpersona_email('This field is required')
			peremailRef.current.focus();
			return false;
		} else if (dateofbirth == '') {
			setEmp_profile(1)
			setErr('red')
			setErrMsgdateofbirth('This field is required')
			dobRef.current.focus();
			return false;
		} else if (company == '') {
			setEmp_spc(1)
			setErr('red')
			setErrMsgcompany('This field is required')
			companyRef.current.focus();
			return false;
		} else if (division == '') {
			setEmp_spc(1)
			setErr('red')
			setErrMsgdivision('This field is required')
			divisionRef.current.focus();
			return false;
		}
		else if (department == '') {
			setEmp_spc(1)
			setErr('red')
			setErrMsgdepartment('This field is required')
			deptRef.current.focus();
			return false;
		}
		else if (dateofjoining == '') {
			setEmp_spc(1)
			setErr('red')
			setErrMsgdateofjoining('This field is required')
			dofjRef.current.focus();
			return false;
		}
		else if (designation == '') {
			setEmp_spc(1)
			setErr('red')
			setErrMsgdesignation('This field is required')
			designationjRef.current.focus();
			return false;
		}
		else if (empcategory == '') {
			setEmp_spc(1)
			setErr('red')
			setErrMsgempcat('This field is required')
			empcatRef.current.focus();
			return false;
		}

		else if (shift == '') {
			setEmp_spc(1)
			setErr('red')
			setErrMsgShift('This field is required')
			empshiftRef.current.focus();
			return false;
		}
		else {
			// console.log('skillData===========================================');
			// console.log(skillData);return false;
			const date = new Date();
			const date_formate = format(date, 'yyyy-MM-dd HH:m:ss')
			const userId = localStorage.getItem('userId');
			
			
			const response = fetch(SERVER_URL + `api/employee/add`,
				{
					method: 'post',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'authorization': `bearer ${token.value}`
					},
					body: JSON.stringify({
						emailpersonal: persona_email,
						city: '',
						state: '',
						pincode: '',
						add: '',
						contact: contact_number,
						timezone: timezone,
						salutation: salutation,
						fname: fname,
						mname: mname,
						lname: lname,
						gurgaon: gargen,
						gender: gender,
						dateofbirth: dateofbirth,
						marriage: marriage,
						bloodgroup: bloodgroup,
						nationality: nationality,
						adhaarname: adhaarname,
						adhaarnumber: adhaarnumber,
						pancardnumber: pancardnumber,
						comp: company,
						division: division,
						dept: department,
						empcode: empcode,
						status: empstatus,
						joiningdate: dateofjoining,
						probation_period: probation_period,
						confirmationdate: confirmationdate,
						role: designation,
						reporting_manager: reportingmanager,
						noticeperiod: noticeperiod,
						salaryType: salaryType,
						ctc: ctc,
						bankname: bankname,
						accountnumber: accountnumber,
						ifsc: ifsc,
						pfapplicable: pfapplicable,
						pfnumber: pfnumber,
						pfgroup: pfgroup,
						pt_applicable: pt_applicable,
						uan_number: uan_number,
						systemRole: systemRole,
						usertype: empcategory,
						created_on: date_formate,
						created_by: userId,
						shift:shift
					}),
				}).then(res => res.json())
				.then(data => {
					//console.log('add emp')
					//console.log(data);return false;
					if (data.status === true) {
						addUserSkill(data.lastID);
						setErrmsg('Employee, Successfully Added')
						setColor('green')
						setTimeout(function () {
							navigate("/employeelist");
						}, 1000);
					} else {
						setErrmsg('Error! Something went wrong')
						setbuttonstatus(false)
						setColor('red')
					}
				})
				
		}
	const addUserSkill = (id) =>{
		if(skillData){
			const userSkill = {
				user_id:id,
				skillData
			}
			// console.log('user skill')
			// console.log(userSkill);
			httpCreateUserGroup(userSkill)
		}
	}
	}
	// const handleEmail = () => {
	// 	setOfficialemailstatus(!officialemailstatus)
	// }
	const [emp_profile, setEmp_profile] = useState(1);
	const [emp_spc, setEmp_spc] = useState(0);
	const [emp_dtl, setEmp_dtl] = useState(0);
	const [emp_skill,seEmp_skill] = useState(0);
	const handleTab = (tab_id) => {
		setEmp_profile(0)
		setEmp_spc(0)
		setEmp_dtl(0)
		seEmp_skill(0)
		if (tab_id == 1) {
			setEmp_profile(tab_id)
		} else if (tab_id == 2) {
			setEmp_spc(tab_id)
		}
		else if (tab_id == 3) {
			setEmp_dtl(tab_id)
		}
		else if (tab_id == 4) {
			seEmp_skill(tab_id)
		}
	}
	const [locationlist, setLocationlist] = useState([])
	const getLocation = async (page) => {
		const response = await fetch(SERVER_URL + `api/common/time-zone-list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setLocationlist(data.result)
				}
			})
	}
	return (
		<>

			<div className="page-header">
				<h1>Add Employee</h1>
				<ul id="breadcrumbs" className="breadcrumb mb00">
					<li>
						<Link to="/dashboard">Dashboard </Link>
					</li>
					<li>
						<Link to='/employeelist'><span>/</span>Employee List </Link>
					</li>
					<li className="current">
						<span>/</span>Add Employee
					</li>
				</ul>
			</div>

			<div className="row_bg">
				<div className="profile_wrapper mb30">
					<div className="nav" id="profile-tab" role="tablist" aria-orientation="vertical">

					<Link className={`nav-link ${emp_profile ? 'active' : ''}`} onClick={(e) => { handleTab(1) }}>
						Employment Profile
					</Link>
					<span className="middleline"></span>
					<Link className={`nav-link ${emp_spc ? 'active' : ''}`} onClick={(e) => { handleTab(2) }}>
						Employment Specifics
					</Link>
					<span className="middleline"></span>
					<Link className={`nav-link ${emp_dtl ? 'active' : ''}`} onClick={(e) => { handleTab(3) }}>
						Other Detail
					</Link>
				</div>
				<div className="tab-content" id="profile-tabContent">
					<div className={`tab-pane fade ${emp_profile ? 'show active' : ''}`} id="employmentprofile" role="tabpanel" aria-labelledby="employmentprofile-tab">
						<div className="tab_content">
							<div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Salutation</div>
										<div className="form-input col-md-8">
											<span style={{ color: err }}>{errMsgsalutaion}</span>
											<select ref={salutationRef} value={salutation} onChange={(e) => { setSalutation(e.target.value) }} className="form-select">
												<option value=''>Select</option>
												<option value='1'>Mr</option>
												<option value='2'>Ms</option>
												<option value='3'>Mrs</option>
											</select>
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">First Name</div>
										<div className="form-input col-md-8">
											<span style={{ color: err }}>{errMsgfname}</span>
											<input ref={fnameRef} autoComplete="none" value={fname} onChange={(e) => { setFname(e.target.value) }} type="text" placeholder="Enter First Name" className="form-control form-control1" />
										</div>
									</div>
								</div>
							</div>
							<div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Middle Name</div>
										<div className="form-input col-md-8">
											<input autoComplete="none" value={mname} onChange={(e) => { setMname(e.target.value) }} type="text" placeholder="Enter Middle Name" className="form-control form-control1" />
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Last Name</div>
										<div className="form-input col-md-8">
											<input autoComplete="none" value={lname} onChange={(e) => { setLname(e.target.value) }} type="text" placeholder="Enter Last Name" className="form-control form-control1" />
										</div>
									</div>
								</div>
							</div>

								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Personal Email</div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgpersona_email}</span>
												<input ref={peremailRef} autoComplete="none" value={persona_email} onChange={(e) => { setPersonal_email(e.target.value) }} type="text" placeholder="Enter Personal Email" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Contact Number</div>
											<div className="form-input col-md-8">
												<input autoComplete="none" value={contact_number} onChange={(e) => { setContact_number(e.target.value) }} type="text" placeholder="Enter Contact Number" className="form-control form-control1" />
											</div>
										</div>
									</div>
								</div>
								{/* <div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Official Email </div>
										<div className="form-input col-md-8">
											<input checked={officialemailstatus ? 'checked' : ''} onChange={handleEmail} onc type="checkbox" /> Create Yes/No
										</div>
									</div>
								</div>
							</div> */}

								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Father/Husband</div>
											<div className="form-input col-md-8">
												<input value={gargen} autoComplete="none" onChange={(e) => { setGargen(e.target.value) }} type="text" placeholder="Enter Father/Husband Name" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Gender</div>
											<div className="form-input col-md-8">
												<select value={gender} onChange={(e) => { setGender(e.target.value) }} className="form-select">
													<option value='1'>Male</option>
													<option value='2'>Female</option>
												</select>
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Date Of Birth</div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgdateofbirth}</span>
												<input ref={dobRef} onChange={(e) => { setDateofbirth(e.target.value) }} type="date" className="form-control" name="" value={dateofbirth} placeholder="Select Date Of Birth" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Marital Status</div>
											<div className="form-input col-md-8">
												<select value={marriage} onChange={(e) => setMarriage(e.target.value)} className="form-select">
													<option value='1'>Married</option>
													<option value='2'>Unmarried</option>
												</select>
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Blood group</div>
											<div className="form-input  col-md-8">
												<input type="text" value={bloodgroup} onChange={(e) => setBloodgroup(e.target.value)} placeholder="Enter blood group" className="form-control form-control1" />
											</div>
										</div>
									</div>

									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Nationality</div>
											<div className="form-input col-md-8">
												<input type="text" value={nationality} onChange={(e) => setNationality(e.target.value)} placeholder="Enter Nationality" className="form-control form-control1" />
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Aadhaar Name </div>
											<div className="form-input col-md-8">
												<input type="text" value={adhaarname} onChange={(e) => setAdhaarname(e.target.value)} placeholder="Enter Aadhaar Card Name" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Aadhaar Number</div>
											<div className="form-input col-md-8">
												<input type="text" value={adhaarnumber} onChange={(e) => setAdhaarnumber(e.target.value)} placeholder="Enter Aadhaar Card Number" className="form-control form-control1" />
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Pan Number</div>
											<div className="form-input col-md-8">
												<input value={pancardnumber} onChange={(e) => setPancardnumber(e.target.value)} type="text" placeholder="Enter Pan Card Number" className="form-control form-control1" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Time Zone </div>
											<div className="form-input col-md-8">
												<select value={timezone} onChange={(e) => setTimezone(e.target.value)} className="form-select">
													<option value=''>Select Time Zone</option>
													{locationlist?.map((item, ind) =>
														<option value={item.location_id}>{item.timezone}</option>
													)}
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className={`tab-pane fade ${emp_spc ? 'show active' : ''}`} id="employmentspecifics" role="tabpanel" aria-labelledby="employmentspecifics-tab">
							<div className="tab_content">
								<div className="tab_sub_ttl">Organization</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Company</div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgcompany}</span>
												<select ref={companyRef} value={company} onChange={(e) => setCompany(e.target.value)} className="form-select">
													<option value=''>Select Company</option>
													{
														comdata?.map((item, ind) => (
															<option key={ind} value={item.id}>{item.name}</option>
														))}
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Division</div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgdivision}</span>
												<select ref={divisionRef} value={division} onChange={(e) => setDivision(e.target.value)} className="form-select">
													<option value=''>Select Division</option>
													{
														comdata?.map((item, ind) => (
															<option key={ind} value={item.id}>{item.division}</option>
														))}
												</select>
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Department</div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgdepartment}</span>
												<select ref={deptRef} value={department} onChange={e => handleChange(e.target.value)} className="form-select">
													<option value=''>Select Department</option>
													{
														depdata?.map((item, ind) => (
															<option key={ind} value={item.id}>{item.name}</option>
														))}
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">System Role</div>
											<div className="form-input col-md-8">
												<select className="form-select" onChange={(e) => { setSystemRole(e.target.value) }}>
													<option value=''>Select system role</option>
													<option value="1">Employee</option>
													<option value="2">Hr Executive</option>
													<option value="3">Manager</option>
													<option value="4">Senior Executive</option>
													<option value="5">Executive</option>
													<option value="6">Leadership</option>
													<option value="7">Finance Manager</option>
													<option value="8">Project Manager</option>
													<option value="9">IT Manager</option>
												</select>
											</div>
										</div>
									</div>
								</div>

								<div className="tab_sub_ttl">Employee Details</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Employee Code</div>
											<div className="form-input col-md-8">
												<input type="text" value={empcode} onChange={(e) => setEmpcode(e.target.value)} placeholder="Enter Employee Code" className="form-control form-control1" />
											</div>
										</div>
									</div>

									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Employee Status</div>
											<div className="form-input col-md-8">
												<select value={empstatus} onChange={(e) => setEmpstatus(e.target.value)} className="form-select">
													<option value='1'>Active</option>
													<option value='2'>Inactive</option>
												</select>
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Date of joining</div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgdateofjoining}</span>
												<input ref={dofjRef} type="date" value={dateofjoining} onChange={(e) => setDateofjoining(e.target.value)} className="form-control" placeholder="Select Date of joining" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Probation Period</div>
											<div className="form-input col-md-8">
												<input type="text" onChange={(e) => setProbation_period(e.target.value)} value={probation_period} placeholder="Enter Probation Period (month)" className="form-control form-control1" />
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Confirmation Date</div>
											<div className="form-input col-md-8">
												<input value={confirmationdate} onChange={(e) => setConfirmationdate(e.target.value)} type="date" className="form-control" placeholder="Select Confirmation Date" />
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Designation </div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgdesignation}</span>
												<select ref={designationjRef} value={designation} onChange={(e) => setDesignation(e.target.value)} className="form-select">
													<option value=''>Select Designation </option>
													{
														roledata?.map((item, ind) => (
															<option key={ind} value={item.id}>{item.name}</option>
														))
													}
												</select>
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Employee Category</div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgempcat}</span>
												<select ref={empcatRef} value={empcategory} onChange={(e) => setEmpcategory(e.target.value)} className="form-select">
													<option value=''>Select Employee Category</option>
													<option value='1'>Onroll</option>
													<option value='2'>Contract</option>
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Notice Period (Days) </div>
											<div className="form-input col-md-8">
												<input value={noticeperiod} onChange={(e) => setNoticeperiod(e.target.value)} type="text" placeholder="Enter Notice Period" className="form-control form-control1" />
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Reporting  </div>
											<div className="form-input col-md-8">
												<select value={reportingmanager} className="form-select" onChange={(e) => { setreportingmanager(e.target.value) }}>
													<option value=''>Select Reporting</option>
													{
														reportimgManageList.map((item, ind) => {
															return <option value={item.id}>{item.name}</option>
														})
													}
												</select>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Final Reporting </div>
											<div className="form-input col-md-8">
												<div className="form-check formcheck1">
													<input className="form-check-input" type="checkbox" value="" id="level1" />
													<label className="form-check-label" htmlFor="level1">
														Level 1
													</label>
												</div>
												<div className="form-check formcheck1">
													<input className="form-check-input" type="checkbox" value="" id="level2" />
													<label className="form-check-label" htmlFor="level2">
														Level 2
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Shift Time</div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgShift}</span>
												<select ref={empshiftRef} value={shift} className="form-select" onChange={(e) => { setShift(e.target.value) }}>
													<option value=''>Select Shift</option>
													{
														shiftList.map((item, ind) => {
															return <option value={item.id}>{item.Name}</option>
														})
													}
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					<div className={`tab-pane fade ${emp_dtl ? 'show active' : ''}`} id="detail" role="tabpanel" aria-labelledby="detail-tab">
						<div className="tab_content">
							<div className="tab_sub_ttl">Remuneration</div>
							<div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Salary Type</div>
										<div className="form-input col-md-8">
											<select className="form-select">
												<option value=''>Select Salary Type</option>
												<option value='1'>Monthly Basis</option>
												<option value='2'>Daily Basis</option>
											</select>
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">CTC (Rs)</div>
										<div className="form-input col-md-8">
											<input type="text" placeholder="Enter CTC" className="form-control form-control1" />
										</div>
									</div>
								</div>
							</div>
							<div className="tab_sub_ttl">Bank Details</div>
							<div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Salary Bank</div>
										<div className="form-input col-md-8">
											<select value={bankname} onChange={(e) => setBankname(e.target.value)} className="form-select">
												<option value=''>Select Salary Type</option>
												<option value='1'>HDFC Bank</option>
												<option value='2'>Federal Bank</option>
												<option value='3'>IDFC FIRST Bank</option>
												<option value='4'>RBL Bank</option>
											</select>
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Account Number</div>
										<div className="form-input col-md-8">
											<input value={accountnumber} onChange={(e) => setAccountnumber(e.target.value)} type="text" placeholder="Enter Salary Account Number" className="form-control form-control1" />
										</div>
									</div>
								</div>
							</div>
							<div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">IFSC Code</div>
										<div className="form-input col-md-8">
											<input value={ifsc} onChange={(e) => setIfsc(e.target.value)} type="text" placeholder="Enter Salary IFSC Code" className="form-control form-control1" />
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">PF Applicable</div>
										<div className="form-input col-md-8">
											<select value={pfapplicable} onChange={(e) => setPfapplicable(e.target.value)} className="form-select">
												<option value=''>Select PF Applicable</option>
												<option value='1'>Yes</option>
												<option value='2'>No</option>
											</select>
										</div>
									</div>
								</div>
							</div>
							<div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">PF Number</div>
										<div className="form-input col-md-8">
											<input value={pfnumber} onChange={(e) => setPfnumber(e.target.value)} type="text" placeholder="Enter PF Number" className="form-control form-control1" />
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">PF Group</div>
										<div className="form-input col-md-8">
											<select value={pfgroup} onChange={(e) => setPfgroup(e.target.value)} className="form-select">
												<option value=''>Select PF Group</option>
												<option value='1'>Yes</option>
												<option value='2'>No</option>
											</select>
										</div>
									</div>
								</div>
							</div>
							<div className="row mb25">
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">PT Applicable</div>
										<div className="form-input col-md-8">
											<select className="form-select" onChange={(e) => { setPt_applicable(e.target.value) }}>
												<option value=''>Select PT Group</option>
												<option value='1'>Yes</option>
												<option value='2'>No</option>
											</select>
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">UAN Number</div>
										<div className="form-input col-md-8">
											<input type="text" onChange={(e) => { setUan_number(e.target.value) }} placeholder="Enter UAN Number" className="form-control form-control1" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="tab_footer text-end">
						<span style={{ color: color ? color : '' }}>{errmsg}</span>
						<button style={{ display: buttonstatus == true ? '' : 'none' }} className="btn_5" onClick={e => handleAddEMP()}>Save</button>
						<button className="btn_6 ml10">Cancel</button>
					</div>
				</div>
			</div></div>
		</>
	)
}
export default AddEmployeeCom
